import Marquee from "react-fast-marquee";
import { SPONSORS } from "@/data/agenticHackathon";
import HoverLift from "@/components/motion/HoverLift";

function SponsorChip({ name, tag, logo, logoOnDark, url }) {
    const card = (
        <div className="flex items-center gap-3 sm:gap-4 rounded-2xl border border-black/[0.08] bg-white px-4 py-3 sm:px-6 sm:py-4 shadow-sm min-w-[180px] sm:min-w-[220px] motion-card">
            {logo ? (
                <div
                    className={`flex h-11 w-11 sm:h-12 sm:w-12 shrink-0 items-center justify-center rounded-xl overflow-hidden ${
                        logoOnDark ? "bg-zinc-950" : "bg-zinc-50"
                    }`}
                >
                    <img
                        src={logo}
                        alt=""
                        className="h-7 sm:h-8 w-auto max-w-[44px] sm:max-w-[48px] object-contain"
                    />
                </div>
            ) : (
                <span className="flex h-9 w-9 sm:h-10 sm:w-10 shrink-0 items-center justify-center rounded-xl bg-zinc-950 text-white font-display text-sm font-black">
                    {name.charAt(0)}
                </span>
            )}
            <div className="text-left min-w-0">
                <p className="text-xs sm:text-sm font-semibold text-zinc-900 truncate">
                    {name}
                </p>
                {tag ? (
                    <p className="text-[10px] sm:text-[11px] font-mono uppercase tracking-wider text-zinc-500 truncate">
                        {tag}
                    </p>
                ) : null}
            </div>
        </div>
    );

    const inner = <HoverLift className="inline-flex shrink-0">{card}</HoverLift>;

    if (url) {
        return (
            <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="mx-2 sm:mx-3 inline-flex shrink-0 rounded-2xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#E54D2E]"
                aria-label={`${name} — opens sponsor website`}
            >
                {inner}
            </a>
        );
    }

    return <span className="mx-2 sm:mx-3 inline-flex shrink-0">{inner}</span>;
}

export default function SponsorsMarquee() {
    const items = [...SPONSORS, ...SPONSORS];

    return (
        <section
            data-testid="sponsors-marquee"
            className="py-10 sm:py-12 md:py-16 border-y border-black/[0.06] bg-[#FAFAFA] overflow-hidden"
        >
            <p className="text-center text-[10px] sm:text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 mb-6 sm:mb-8 px-4">
                Proudly supported by
            </p>
            <Marquee
                gradient
                gradientColor="#FAFAFA"
                speed={35}
                pauseOnHover
                className="min-h-[88px]"
            >
                {items.map((s, i) => (
                    <SponsorChip
                        key={`${s.name}-${i}`}
                        name={s.name}
                        tag={s.tag}
                        logo={s.logo}
                        logoOnDark={s.logoOnDark}
                        url={s.url}
                    />
                ))}
            </Marquee>
        </section>
    );
}
